module.exports = __webpack_public_path__ + "static/img/12.14ea0d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/12.jpg
// module id = svrV
// module chunks = 1